export default function WhoUsesHarborAgent() {
  const users = [
    "Energy-sector software vendors",
    "Grid operations technology providers",
    "Applied AI companies",
    "Scientific computing partners",
    "Federal contractors",
    "Industrial R&D teams (materials, climate, fusion, power)"
  ]

  return (
    <section className="section-padding bg-gray-50">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Who Uses Harbor Agent
            </h2>
            <p className="text-xl text-gray-600">
              Harbor Agent packs are designed for teams preparing for credible collaboration with government initiatives
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {users.map((user, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-lg border border-gray-200 hover:border-primary-300 transition-colors"
              >
                <div className="flex items-start">
                  <span className="text-primary-600 mr-3 mt-1">•</span>
                  <span className="text-gray-700 text-lg">{user}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

